export const rootRouter = {
  path: "/",
  component: "BasicLayout",
  redirect: "/enterprise-list/list",
  meta: {
    title: "首页",
    name: "main",
    key: "main"
  },
  children: [],
  isRoot: true
};
